import styled from "styled-components";
import fipayFonts from "../../theme/index";
import { colors } from "../../theme/color";

export const CreateLinkBigContainer = styled.div`
  /* padding-left: 30px; */
`;

export const CreateContentWrapper = styled.div`
  padding-top: 40px;
`;

export const CreateLinkSubHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const CreateLinkText = styled.h4`
  font-weight: 500;
  font-size: 26px;
  color: #09005b;
  letter-spacing: 0.5px;
  margin-top: 15px;
`;

export const CreateGoback = styled.span`
  padding-left: 10px;
  //styleName: Web/Footer/F1Regular;
  font-family: GT Walsheim Pro;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.02em;
  color: #5e5e5e;
`;

export const CharityPaymentLinkContainer = styled.div<{
  $noSelection: boolean;
}>`
  width: ${({ $noSelection }) => ($noSelection ? "78vw" : "612px")};
  height: ${({ $noSelection }) => ($noSelection ? "70vh" : "none")};
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid var(--General-Stroke, #e8eaed);
  background: var(--General-White, #fff);
  box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);
  padding: 20px 16px 24px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media screen and (max-width: 430px) {
    width: 100%;
  }
  @media screen and (max-width: 327px) {
    width: 327px;
  }
`;

export const CharityPaymentLinkHeader = styled.div`
  width: 100%;
  height: 32px;
  /* border: 2px solid blue; */
  /* padding: 20px 16px 20px 20px;
  box-sizing: border-box; */
`;

export const HeaderTitle = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.fontSize.body1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
  color: ${colors.PURPLE};

  /* @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  } */
  /* @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  } */

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.body1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
    text-align: left;
  }

  @media screen and (max-width: 327px) {
    font-size: ${fipayFonts.fipayFonts.body1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
    text-align: left;
  }
`;

export const SubtitleText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.body2.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
  color: ${colors.DARK_GRAY};

  @media screen and (max-width: 2560px) {
    font-size: ${fipayFonts.fipayFonts.body1.size};
  }

  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};

    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }
`;

export const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e8eaed;
  /* margin-top: 16px; */
`;

export const PaymentLinkTypeContainer = styled.div`
  width: 100%;
  // height: 204px;
  /* width: 576px; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  /* border: 2px solid orange; */
  @media screen and (max-width: 430px) {
    // height: 300px;
  }
  @media screen and (max-width: 327px) {
    // height: 300px;
  }
`;

export const PaymentLinkTypeTitle = styled.div`
  /* margin-top: 5px; */
  margin-bottom: 5px;
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
  color: ${colors.BLACK};

  /* @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  } */
  /* @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  } */

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    text-align: left;
  }

  @media screen and (max-width: 327px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    text-align: left;
  }
`;

export const LinkTypeHolder = styled.div`
  width: 100%;
  display: flex;
  /* flex-direction: column; */
  align-items: flex-start;
  flex-wrap: wrap;
  /* gap: 16px; */
  /* border: 2px solid blue; */

  @media screen and (max-width: 430px) {
    width: 280px;
    // height: 248px;
    flex-direction: column;
    gap: 10px;
    flex-wrap: nowrap;
  }
  @media screen and (max-width: 327px) {
    width: 280px;
    // height: 248px;
    flex-direction: column;
    gap: 10px;
    flex-wrap: nowrap;
  }
`;

export const CharityInputContainer = styled.div`
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
  /* border: 2px solid blue; */
`;

export const CharityInputContainer1 = styled.div`
  width: 100%;
  display: inline-flex;
  flex-direction: space-around;
  align-items: center;
  margin: 0 auto;
  padding-top: 10px;
  padding-bottom: 10px;
  //   border: 2px solid blue;
`;

export const CharityInputContainer2 = styled.div`
  width: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 20px;
  //   border: 2px solid blue;
`;

export const CharityInputContainer3 = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin: 0;
  padding-left: 0;
  padding-top: 5px;
  //   border: 2px solid blue;
`;

export const CharityInputContainer4 = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding-left: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  //   border: 2px solid blue;
`;

export const CreateInputField = styled.input`
  width: 20%;
  padding: 10px;
  /* border: 1px solid #ccc; */
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 5px;

  &:focus {
    outline: none;
    border-color: #000;
  }
`;

export const CreateLabel = styled.label`
  font-weight: 400;
  font-size: 14px;
  margin-left: 20px;
  margin-right: 10px;
`;

export const CreateLabel1 = styled.label`
  font-weight: 400;
  font-size: 14px;
  // border: 2px solid red;
  margin-left: -30px;
  //   margin-right: 10px;
`;

export const CreateInputField1 = styled.select`
  width: 70%;
  height: 30px;
  padding: 0px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin: 5px;

  &:focus {
    outline: none;
    border-color: #000;
  }
`;

export const CreateInputField2 = styled.input`
  width: 70%;
  height: 30px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin: 5px;
`;

export const CreateLabel2 = styled.label`
  font-weight: 400;
  font-size: 14px;
  margin: 0;
`;

export const OptionsContainer = styled.div`
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 15px;
  gap: 10px;
  /* border: 2px solid black; */
  @media screen and (max-width: 430px) {
    width: 100%;
  }
  @media screen and (max-width: 327px) {
    width: 100%;
  }
`;

export const CheckBox = styled.input`
  width: 16px;
  height: 16px;
  display: inline-flex;
  padding-top: 2px;
  justify-content: center;
  align-items: center;
  appearance: none;
  border: 2px solid ${(props) => (props.checked ? "#00A603" : "#ccc")};
  border-radius: 4px;
  outline: none;
  position: relative;

  &:checked {
    background-color: #ccf4cd;
    border-color: #00a603;
  }

  &:checked::before {
    content: "";
    width: 40%;
    height: 50%;
    border: solid #00a603;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-45%, -60%) rotate(45deg);
  }
`;

export const CheckboxLabel = styled.label`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
  color: ${colors.BLACK};

  /* @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  } */
  /* @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  } */

  /* @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.body1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
    text-align: left;
  } */

  /* @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
    text-align: left;
  } */
`;

export const RadioContainer = styled.div`
  display: flex;
  width: 100%;
  /* justify-content: space-evenly; */
  align-items: center;
  gap: 5px;
`;

export const ButtonHolder = styled.div`
  display: flex;
  width: 184px;
  height: 44px;
  justify-items: flex-end;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const ShowAdvancedOpt = styled.span`
  width: 70%;
  margin: 0 auto;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  color: ${colors.GREEN};
  cursor: pointer;
`;

export const AdvancedOptionMain = styled.div`
  padding: 30px 0;
`;

export const TaxCategorySelectArea = styled.select`
  width: 70%;
  height: 30px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 5px;
`;

export const PreviewOfPaymentCreate = styled.div`
  padding-left: 40px;
  @media screen and (max-width: 768px) {
    padding-left: 0;
  }
`;

export const PaymentLinkCharityInput = styled.input`
  width: 80%;
  height: 44px;
  border: 1px solid #e8eaed;
  border-radius: 12px;
  text-indent: 8px;

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }
`;

export const PreviewAddNewGreen = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: default;
  padding: 5px 0px 35px 0px;
`;

export const PreviewAddNewGreenSpan = styled.span`
  color: ${colors.GREEN};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
`;

export const SelectPopMain = styled.div`
  box-shadow: -3px 5px 15px 0px #b0b0b040;
  width: 81%;
`;

export const SelectPopContent = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0px 10px 30px;
  background: #ffffff;
  border: 1px solid #e8eaed;
  height: 35px;
  cursor: default;
  border-radius: 10px;
`;

export const SelectPopSpan = styled.span`
  font-size: 14px;
  font-weight: 400;
  cursor: default;
`;

export const SearchContainer = styled.div`
  box-shadow: -3px 5px 15px 0px #b0b0b040;
  width: 81%;
`;
export const PaymentLinkWrap = styled.div`
  display: flex;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;
